module.exports = Object.freeze({
    COMPANY: 1,
    PROJECT: 2,
    FUND: 3,
    FUND_SUBSIDIARY: 4,
    DIVISION: 5,
    BUILDER: 6,
    USER: 7,
    LOT_TYPE: 8,
    LOT: 9,
    PHASE: 10,
    TAKEDOWN: 11,
    TAKEDOWN_STATUS: 12,
    REGION: 13,
    BANK: 14,
    BANK_ACCOUNT: 15
});



// WEBPACK FOOTER //
// ./client/app/_helpers/nodeType.js